import { useState } from 'react';
import { Modal } from './ui';
import { platesPerSide, estimate1RM } from '../lib/calc';

const BARS = [
  { value: 20, label: '20 kg (olympique)' },
  { value: 15, label: '15 kg (courte)' },
  { value: 10, label: '10 kg (barre EZ)' },
  { value: 0, label: '0 kg (machine)' },
];

const num = (v) => (v === '' || v == null ? NaN : parseFloat(v));

// Disques empilés de chaque côté de la barre, colorés comme dans une salle (25 rouge, 20 bleu, 15 jaune…)
export function PlateStack({ plates }) {
  return (
    <div className="plate-stack" aria-label={`Disques : ${plates.join(', ')} kg`}>
      <div className="plate-bar plate-bar--end" />
      {plates.map((p, i) => (
        <div key={i} className={`plate-disc plate-${String(p).replace('.', '_')}`}><span>{p}</span></div>
      ))}
      <div className="plate-bar plate-bar--tip" />
    </div>
  );
}

export function PlateCalculator({ initialWeight = '', reps = null }) {
  const [target, setTarget] = useState(initialWeight === null ? '' : String(initialWeight));
  const [bar, setBar] = useState(20);
  const total = num(target);
  const { plates, remainder } = platesPerSide(total, bar);
  const perSide = plates.reduce((a, b) => a + b, 0);
  const oneRm = reps > 1 ? estimate1RM(total, reps) : null;

  return (
    <div>
      <div className="form-row">
        <div className="form-group"><label className="form-label">Charge totale (kg)</label>
          <input type="number" min="0" step="0.5" className="form-input" value={target} onChange={(e) => setTarget(e.target.value)} autoFocus /></div>
        <div className="form-group"><label className="form-label">Barre</label>
          <select className="form-select" value={bar} onChange={(e) => setBar(Number(e.target.value))}>
            {BARS.map((b) => <option key={b.value} value={b.value}>{b.label}</option>)}
          </select></div>
      </div>
      {target !== '' && total > bar && plates.length > 0 && (
        <div className="plate-result">
          <p className="muted small">Charger <strong>{perSide} kg</strong> de chaque côté de la barre ({bar} kg) :</p>
          <PlateStack plates={plates} />
          <div className="chips">{plates.map((p, i) => <span key={i} className="chip plate">{p} kg</span>)}</div>
          {remainder > 0 && <p className="muted small">Reste {remainder} kg non réalisable avec les disques standards.</p>}
        </div>
      )}
      {target !== '' && total > 0 && total <= bar && <p className="muted">Barre seule, aucun disque à ajouter.</p>}
      {oneRm ? <p className="muted small">1RM estimé : <strong>{Math.round(oneRm)} kg</strong></p> : null}
    </div>
  );
}

export function PlateModal({ weight, reps, exerciseName, onClose }) {
  return (
    <Modal title={`🛞 Disques${exerciseName ? ` — ${exerciseName}` : ''}`} onClose={onClose}>
      <PlateCalculator initialWeight={weight} reps={reps} />
    </Modal>
  );
}
